import { Setup } from "appworks/boot/setup";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { SlotWorks } from "slotworks/slotworks";

class Ygg {

    public licensesAutoplayDisabled: string[] = ["de", "lt", "fin", "agcc", "uk", "ukgcrtstest"];
    public licensesSubstakeCelebrationsDisabled: string[] = ["uk", "agcc", "ukgcrtstest"];
    public symbolMap: Map<string | number, number> = new Map<string, number>();
    public scatterSymbols: string[] = [];

    public go(setups: Setup | Setup[], assetworksData: any): void {
        PartnerConnectManager.load().then(() => {
            SlotWorks.go(setups, assetworksData);
        });
    }

    public goToLobby(): void {
        PartnerConnectManager.getUI()?.clickActionHandler().home();
    }

    public showHistory(): void {
        PartnerConnectManager.getUI()?.showGameHistory({});
    }
}

export const ygg = new Ygg();
